import { useTranslation } from 'react-i18next';
import { SLASH_COMMANDS } from '@/lib/slashCommands';

/** Slash-command picker rendered above the composer. Shows the cmd label,
 *  a short description, and slide-on-hover for the focused row. Click /
 *  Enter / Tab on a row expands the draft to the command stub. */
export function SlashPopup(props: {
  commands: typeof SLASH_COMMANDS;
  selected: number;
  onPick: (c: (typeof SLASH_COMMANDS)[number]) => void;
  onHover: (idx: number) => void;
}) {
  const { t } = useTranslation();
  return (
    <div className="bg-surface rounded-xl border border-separator absolute bottom-full left-0 right-0 mb-2 overflow-hidden">
      <div className="font-medium flex items-baseline justify-between px-3 pt-2 pb-1 text-[10px] text-ink-muted">
        <span>{t('ui.slash.command')}</span>
        <span className="font-mono text-[10px] text-ink-muted">
          {t('ui.slash.hint')}
        </span>
      </div>
      <ul className="scrollbar-thin max-h-72 overflow-y-auto pb-1">
        {props.commands.map((c, idx) => {
          const active = idx === props.selected;
          return (
            <li key={c.cmd}>
              <button
                type="button"
                onMouseEnter={() => props.onHover(idx)}
                // mousedown beats textarea blur, same trick as MentionPopup.
                onMouseDown={(e) => {
                  e.preventDefault();
                  props.onPick(c);
                }}
                data-active={active}
                className="rounded-lg transition-colors hover:bg-default/50 active:scale-[0.97] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/60 mx-1 flex w-[calc(100%-0.5rem)] items-center gap-3 rounded-lg px-3 py-2 text-left transition-[transform,background-color,border-color,color,box-shadow,opacity] duration-100 hover:translate-x-0.5"
              >
                <span className="grid h-7 w-7 shrink-0 place-items-center rounded-lg bg-accent/15 font-mono text-[11px] text-accent">
                  /
                </span>
                <span className="min-w-0 flex-1">
                  <span className="block truncate font-mono text-[12px] text-ink">
                    {c.label}
                  </span>
                  <span className="mt-0.5 block truncate text-[11px] leading-tight text-ink-muted">
                    {c.description}
                  </span>
                </span>
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
